<mat-dialog-actions class="p-4 dark-bg dark-mode">
    <h3 class="text-white" style="font-size: 22px;">Upload CEU Credits</h3>
</mat-dialog-actions>
<mat-dialog-content class="px-4 dark-bg dark-mode">

    <form [formGroup]="form">
        <div class="row">
            <div class="col-12">
                <mat-form-field class="full-width w-100" appearance="outline" >
                    <mat-label>Certification</mat-label>
                    <mat-select formControlName="certification" >
                        <mat-option *ngFor="let cert of certifications" [value]="cert.id">
                            {{ cert.association.providerName + ' - ' + cert.certificationTitle }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <mat-form-field class="full-width w-100" appearance="outline" >
                    <mat-label>Document Type</mat-label>
                    <mat-select formControlName="documentType">
                        <mat-option *ngFor="let param of documentTypes.parameterMembers" [value]="param.parameterValue">
                            {{ param.parameterLabel }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <mat-form-field class="full-width w-100" appearance="outline" >
                    <mat-label>Activity Type</mat-label>
                    <mat-select formControlName="activity">
                        <mat-option *ngFor="let activity of activityList" [value]="activity.id">
                            {{ activity.activityType }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <app-validity-check
                        [providerActivities]="activities"
                        [form]="form"
                        [mode]="data.mode"
                        [uploading]="uploading"
                        [data]="data.activityResponse"
                        (result)="getValidationCheckResult($event)"></app-validity-check>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="row">
                    <div class="col-12">
                        <app-upload-single
                                (fileChange)="getFileChange($event)"
                                [accept]="'image/*,application/pdf'"
                                [fileUrl]="fileUrl"
                                [labelButton]="'Browse Certificate'"
                                [label]="'Upload Certification'" [readonly]="uploading"
                                [theme]="'dark'"
                        >

                        </app-upload-single>
                    </div>
                </div>
            </div>
        </div>
    </form>
</mat-dialog-content>
<mat-dialog-actions class=" dark-mode p-4 justify-content-end dark-bg">
    <button mat-raised-button (click)="closeDialog()" [disabled]="uploading">Cancel</button>
    <button mat-raised-button color="warn" (click)="resetForm()" [disabled]="uploading">Reset</button>
    <button *ngIf="data.isAdmin" mat-raised-button (click)="saveAdmin()" [disabled]="uploading" class="bg-accent-orange">Save</button>
</mat-dialog-actions>
